import React from 'react'
import {ReactComponent as IconTrend} from '../assets/icons/ic-trend.svg'
import {ReactComponent as IconClose} from '../assets/icons/ic-close.svg'
import {ReactComponent as IconSetting} from '../assets/icons/ic-setting.svg'
import {ReactComponent as IconFullscreen} from '../assets/icons/ic-fullscreen.svg'
import {ReactComponent as IconReduceScreen} from '../assets/icons/ic-reduce.svg'
import {ReactComponent as IconAlarmReview} from '../assets/icons/ic-alarm-review.svg'
import {ReactComponent as IconMeasurements} from '../assets/icons/ic-measurements.svg'
import { useRecoilState } from 'recoil';
import { deviceModelInfo } from '../plugins/recoil';

const HalfMenus = ({selectBedInfo,nowPage,onTrend,onAlarmReview,onMeasurements,onSetting,isFull,isFromSearch,handleFullScreen,onClose}) => {
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);    

    const renderMenusByDeviceModel = () => {
        if (!selectBedInfo) return [];
        const modelInfo = deviceModelMenus.find(item => item.model === selectBedInfo.deviceModel);
        const menus = [];              
        
        if (nowPage !== 'trend' && modelInfo?.trendSupported) {
            menus.push(
                <IconTrend key={`${Math.random()}-trend-icon`} onClick={onTrend} className="mr-1 cursor-pointer"/>
            );
        }

        if(nowPage !== 'alarmReview' && modelInfo?.alarmReviewSupported) {
            menus.push(
                <IconAlarmReview key={`${Math.random()}-alarm-review-icon`} onClick={onAlarmReview} className="mr-1 cursor-pointer"/>
            );
        }      

        // isFromSearch가 true / false 일때 메뉴 노출 제어
        if(!isFromSearch){
            if(nowPage !== 'measurements' && modelInfo?.nibpSupported) {
                menus.push(
                    <IconMeasurements key={`${Math.random()}-measurements-icon`} onClick={onMeasurements} className="mr-1 cursor-pointer" />
                );
            }

            if(nowPage !== 'bedSetting' && modelInfo?.bedSettingSupported) {
                menus.push(
                    <IconSetting key={`${Math.random()}-settings-icon`} onClick={onSetting} className="mr-1 cursor-pointer" />
                );
            }
        }

        if(nowPage == 'trend' || nowPage == 'alarmReview'){
            if (isFull) {
                menus.push(
                    <IconReduceScreen key={`${Math.random()}-reduce-icon`} onClick={() => handleFullScreen()} className="w-[28px] h-[28px] mr-1 cursor-pointer"/>
                );
            }else {
                menus.push(
                    <IconFullscreen key={`${Math.random()}-fullscreen-icon`} onClick={() => handleFullScreen()} className="w-[28px] h-[28px] mr-1 cursor-pointer"/>
                );
            }
        }
        
        menus.push(
            <React.Fragment key={`${Math.random()}-close-fragment`}>
                <div className="w-[1px] h-[24px] bg-[#4E4E4E] mr-1" />
                <IconClose onClick={onClose} className="m-[10px] cursor-pointer" />
            </React.Fragment>            
        );             
        
        return menus;
    }    

    return (
       <div className="flex items-center ml-auto">                        
            {renderMenusByDeviceModel()}
        </div>     
    )
}

export default HalfMenus